// @ts-nocheck
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../store/userSlice";
import { BASE_URL } from "../Constants/BaseUrl";
import axios from "axios";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";

const DeleteAccount = () => {
  const color = {
    layoutBackground: "#121212",
    appTextColor: "#ffffff",
    buttonColor: "#C00000",
    cancelButtonColor: "#333333",
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);

  const handleLogout = async () => {
    setLoading(true);

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${BASE_URL}auth/delete-account`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    };

    try {
      const response = await axios.request(config);
      console.log("Response:", response.data);
      dispatch(logoutUser());

      toast.success("Account deleted successfully", {
        position: "top-right",
        autoClose: 3000,
      });

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      toast.error(error?.response?.data?.error || "Something went wrong", {
        position: "top-right",
        autoClose: 3000,
      });
      console.log("Logout error:", error?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: color.layoutBackground }}
    >
      <div className="w-full max-w-md bg-opacity-80 rounded-lg shadow-lg p-8 flex flex-col items-center">
        <img src={LOGO} alt="Logo" className="h-32 w-36 object-contain mb-4" />
        <img
          src={APPNAME}
          alt="App Name"
          className="h-16 w-48 object-contain mb-5"
        />
        <h2
          className="text-2xl font-bold uppercase text-center mb-4"
          style={{
            color: color.appTextColor,
            fontFamily: "Oswald, sans-serif",
          }}
        >
          Delete Account
        </h2>
        <p
          className="text-center mb-4 text-base"
          style={{
            color: color.appTextColor,
            fontFamily: "Roboto, sans-serif",
          }}
        >
          <span className="font-bold">WARNING: </span>
          You are deleting your account. Once you delete your account, all
          information and media associated with your account will be deleted and
          cannot be recovered.
        </p>
        <button
          onClick={handleLogout}
          disabled={loading}
          className={`w-full py-3 px-4 rounded-md text-white font-semibold uppercase transition-colors ${
            loading
              ? "bg-red-400 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700"
          }`}
          style={{ backgroundColor: loading ? "" : color.buttonColor }}
        >
          {loading ? (
            <svg
              className="animate-spin h-5 w-5 mx-auto text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            "Yes, Delete My Account"
          )}
        </button>
        <button
          onClick={() => navigate(-1)}
          disabled={loading}
          className={`w-full py-3 px-4 mt-4 rounded-md text-white font-semibold uppercase transition-colors ${
            loading
              ? "bg-gray-500 cursor-not-allowed"
              : "bg-gray-600 hover:bg-gray-700"
          }`}
          style={{ backgroundColor: loading ? "" : color.cancelButtonColor }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteAccount;
